import React from "react";
import GerencialTable from "./components/Tables/GerencialTable";
import AgenteTable from "./components/Tables/AgenteTable";
import ConsolidadoTable from "./components/Tables/ConsolidadoTable";
import DescartadosTable from "./components/Tables/DescartadosTable";
import TestadoresTable from "./components/Tables/TestadoresTable";
import RecusaramTable from "./components/Tables/RecusaramTable";

const tabs = [
  "Gerencial",
  "Por Agente",
  "Consolidado",
  "Descartados",
  "Testadores",
  "Recusaram",
];

interface Props {
  tabSelected: string;
  setTabSelected: React.Dispatch<React.SetStateAction<string>>;
}

const Table = ({ tabSelected, setTabSelected }: Props) => {
  switch (tabSelected) {
    case "Gerencial":
      return <GerencialTable {...{ tabSelected, setTabSelected, tabs }} />;
    case "Por Agente":
      return <AgenteTable {...{ tabSelected, setTabSelected, tabs }} />;
    case "Consolidado":
      return <ConsolidadoTable {...{ tabSelected, setTabSelected, tabs }} />;
    case "Descartados":
      return <DescartadosTable {...{ tabSelected, setTabSelected, tabs }} />;
    case "Testadores":
      return <TestadoresTable {...{ tabSelected, setTabSelected, tabs }} />;
    case "Recusaram":
      return <RecusaramTable {...{ tabSelected, setTabSelected, tabs }} />;
    default:
      return null;
  }
};

export default Table;
